<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{ version }}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <em
      class="boton_diagnocat sombraModales"
      v-b-tooltip.hover.v-light.topright="'Consultar estudios diagnocat'"
      @click="flujoInicialDiagnocat(true)"
    ></em>
    <div>
      <b-modal
        title="Visualización de estudios Diagnocat"
        size="xl"
        v-model="mostrarModalHdx"
        centered
        hide-footer
        no-close-on-backdrop
        hide-header-close
      >
        <div style="min-height: 500px; padding: 0 20px">
          <b-row>
            <b-col
            class="pt-3 border-card sidebar-col"
            :cols="colapsado ? 1 : 3"
            :class="{ 'is-collapsed': colapsado }"
          >
            <div class="d-flex align-items-center">
              <b-button
                variant="link"
                class="p-0 toogle-btn"
                @click="colapsado = !colapsado"
                :aria-expanded="(!colapsado).toString()"
                aria-controls="lista-estudios"
                v-b-tooltip.hover.top.v-light
                :title="colapsado ? 'Mostrar lista' : 'Ocultar lista'"
              >
                <b-icon icon="list"></b-icon>
              </b-button>

              <p
                v-show="!colapsado"
                class="m-0 ml-2"
                style="color: #1b81af; font-weight: 600"
              >
                Lista de estudios
              </p>
            </div>

            <div id="lista-estudios" v-show="!colapsado" class="mt-2">
              <div v-for="(estudio, index) in estudios" :key="index">
                <div
                  class="d-flex align-items-center p-1 mb-1"
                  v-if="estudio.vigente && estudio.existe"
                  :class="{
                    'estudio-seleccionado': indexSeleccionado == index,
                  }"
                  @click.stop="seleccionarEstudio(index)"
                >
                  <img
                    @click.stop="abrirCarruselEstudio(estudio)"
                    :src="estudio.miniatura"
                    @error="onImageError($event, estudio)"
                    alt="Img Diagnocat"
                    v-b-tooltip.hover.v-light="estudio.miniaturaFallida ? 'No se encuentra disponible la imagen' : ''"
                    style="width: 50px; height: 50px; border-radius: 10px"
                  />
                  <div class="w-100 ml-2">
                    <p class="m-0 p-0 title-card">
                      {{ estudio.nombreEstudio }}
                    </p>
                    <p class="m-0 p-0" style="font-size: 11px">
                      Fecha de creación:
                      <span>{{ estudio.fechaAlta | formatoFecha }}</span>
                    </p>
                    <p class="m-0 p-0" style="font-size: 11px">
                      Ult. Actualización:
                      <span>{{ estudio.fechaActualizacion | formatoFecha }}</span>
                    </p>
                  </div>
                </div>
                <div
                  v-else
                  class="d-flex align-items-center p-1 mb-1"
                  @click="seleccionarEstudio(index)"
                  :class="{
                    'estudio-seleccionado': indexSeleccionado == index,
                  }"
                >
                  <img
                    src="../../assets/version5/diagnocat.png"
                    alt="Img Diagnocat"
                    style="
                      width: 50px;
                      height: 50px;
                      border-radius: 10px;
                      opacity: 0.5;
                    "
                  />
                  <div class="w-100 ml-2">
                    <p class="m-0 p-0 title-card-inactive">
                      {{ estudio.nombreEstudio }}
                    </p>
                    <p
                      class="m-0 p-0 ml-2"
                      style="font-size: 11px; color: #898989"
                    >
                      No disponible
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-col>

          <b-col
            class="d-flex flex-column pt-3 border-card"
            :cols="colapsado ? 11 : 9"
          >
            <!-- No existe estudio -->
            <div v-if="!estudioSeleccionado" class="w-100 d-flex justify-content-center align-items-center" style="min-height: 100%;">
              <p class="text-center m-0">
                No hay estudios disponibles para este paciente.
              </p>
            </div>

            <!-- Estudio inválido -->
            <div
                v-else-if="!estudioSeleccionado.vigente || !estudioSeleccionado.existe"
                class="w-100 d-flex justify-content-center align-items-center"
                style="min-height: 100%;"
            >
              <p class="text-center m-0">
                Este estudio tiene una vigencia superior a 6 meses o no se
                le ha realizado al paciente.
              </p>
            </div>

            <!-- No hay análisis -->
            <div
                v-else-if="!estudioSeleccionado.analisis || estudioSeleccionado.analisis.length === 0"
                class="w-100 d-flex justify-content-center align-items-center"
                style="min-height: 100%;"
            >
              <p class="m-0">No hay análisis disponibles.</p>
            </div>
            <b-tabs lazy
                      v-model="indiceTabActivo"
                      @input="seleccionarAnalisis"
                      v-if="
                        estudioSeleccionado &&
                        estudioSeleccionado.analisis &&
                        estudioSeleccionado.analisis.length > 0
                      ">
                    <!-- Botón actualizar -->
                  <template #tabs-start>
                    <div
                        @click="flujoInicialDiagnocat(false)"
                        v-b-tooltip.hover.top.v-light
                        title="Actualizar estudios"
                        class="btn-actualizar"
                    >
                      <em class="actualizar" style="width: 20px"></em>
                    </div>
                  </template>
                <b-tab v-for="(analisis, index) in estudioSeleccionado.analisis"
                       :key="analisis.uid"
                       :title="'Diagnóstico ' + (index + 1)">
                  <b-row>
                    <b-col :cols="ventanaDinamica" class="position-relative" >

                      <div
                          class="d-flex justify-content-start align-items-center"
                          style="min-height: 460px"
                      >
                        <div
                            v-if="
                            loadingPdf && true && analisis.pdf == null && estudioSeleccionado.vigente &&
                            estudioSeleccionado.existe
                          "
                            class="w-100 d-flex flex-column align-items-center justify-content-center"
                        >
                          <b-spinner small type="border"></b-spinner>
                          <span class="ml-2">Cargando detalle del estudio</span>
                        </div>
                        <div
                            v-if="
                            estudioSeleccionado.vigente && estudioSeleccionado.existe &&
                            analisis.pdf != null
                          "
                            style="display: contents;"
                        >
                          <iframe
                              title="visorPdf"
                              :src="analisis.pdf"
                              width="100%"
                              style="min-height: 800px"
                          ></iframe>

                        </div>

                        <div
                            class="w-100 d-flex justify-content-center align-items-center"
                            v-else-if="!tieneEstudiosDisponibles"
                        >
                          <p class="text-center">
                            No hay estudios disponibles para este paciente.
                          </p>
                        </div>
                        <div  class="w-100 d-flex justify-content-center align-items-center"
                              v-else-if="error != null">
                          {{ error }}
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="3" v-if="loadingDiagnostico == true" class="d-flex justify-content-center align-items-center w-100">
                      <b-spinner small type="border"></b-spinner>
                      <span class="ml-2">Cargando diagnóstico</span>
                    </b-col>
                    <b-col class="pt-3 border-card" cols="4" v-if="diagnosticos.length > 0">
                      <div class="d-flex justify-content-between align-items-center">
                        <p style="color: #1b81af; font-weight: 600">
                          Padecimientos
                        </p>
                        <b-button
                            :variant="estadoSeleccion === 'todo' ? 'outline-warning' : 'outline-success'"
                            size="sm"
                            @click="toggleTodo"
                        >
                          {{ textoBoton }}
                        </b-button>
                      </div>


                      <div style="height: 70vh; overflow: scroll;">
                        <div v-for="(diag, ind) in diagnosticos" :key="ind"  class="diagnostico-item mr-1">
                          <b-row>
                            <b-col cols="2" class="align-content-center">
                              <div class="tooth-container">
                                <em class="diente_outline tooth-icon-lg"></em>
                                <span class="tooth-number mt-1">{{ diag.numDiente }}</span>
                              </div>
                            </b-col>

                            <b-col cols="10">
                              <div
                                  v-for="(tooth, i) in diag.padecimientos"
                                  :key="i"
                                  style="margin: 6px"
                              >
                                <b-form-checkbox
                                    :id="'checkbox-' + ind + '-' + i"
                                    name="checkbox-1"
                                    v-model="tooth.checked"
                                    @change="seleccionarPad(diag, tooth, $event)"
                                >
                                  {{ tooth.padecimiento }}
                                </b-form-checkbox>
                              </div>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div class="m-1" style="display: flex; justify-content: center">
                        <b-button
                            variant="outline-info"
                            pill
                            :disabled="listaPadecimientos.length === 0"
                            @click="agregarOdontograma"
                        >
                          Agregar en el odontograma
                        </b-button>
                      </div>

                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </div>

        <div class="d-flex justify-content-center" style="width: 100%">
          <b-button
            class="mt-3"
            variant="outline-secondary"
            block
            pill
            @click="cerrarModal()"
            style="width: 10%"
            >Cerrar
          </b-button>
        </div>
      </b-modal>

      <!-- Modal Carrusel (se abre al tocar la miniatura del estudio) -->
      <ImageZoomCarousel
          v-model="modalCarrusel"
          :titulo="tituloCarrusel"
          :urls="carruselUrls"
          :datos-imagenes="carruselAnalisis"
          :indice-inicial="carruselIndex"
      />
    </div>
  </div>
</template>

<script>
import ImageZoomCarousel from "./ImageZoomCarousel.vue";

export default {
  name: "HerramientasModal",
  components: {
    ImageZoomCarousel,
  },
  props: {
    idPaciente: Number,
    idClinica: Number,
    diagInicial: {
      default: false,
      type: Boolean,
    },
    idSesion: Number,
    accionesDiagnocat: Object
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mostrarModalHdx: false,
      loading: false,
      estudios: [],
      estudioSeleccionado: null,
      indexSeleccionado: null,
      modalImgCompleta: false,
      estudioParaMiniatura: null,
      estudiosBase: [],
      pacienteDiagnocat: null,
      estudiosPaciente: null,
      colapsado: false,
      vistaPDF: null,
      loadingPdf: false,
      diagnosticos: [],

      listaDientes: [],
      listaPadecimientos: [],
      loadingDiagnostico: false,
      error: null,
      // Carrusel
      modalCarrusel: false,
      carruselUrls: [],
      carruselIndex: 0,
      tituloCarrusel: "",
      carruselAnalisis: [],
      // Control del tab activo en b-tabs
      indiceTabActivo: 0,
      // Control para cancelar descargas de PDF anteriores
      descargaPdfActual: null,
      // Bitacora de acciones en diagnocat
      accionDiagnocat: {
        idPaciente: null,
        idEstudio: null,
        idAnalisis: null,
        idAccion: [],
        idSesion: null,
      }
    };
  },
  async created() {
    this.estudioSeleccionado = null;
    this.debug = this.$localStorageService.getDebug();
  },
  watch: {},
  computed: {
    
      ventanaDinamica() {
        return this.diagnosticos.length > 0 || this.loadingDiagnostico == true ? 8 : 12
      }, 
    totalPadecimientos() {
      return this.diagnosticos.reduce(
        (acc, d) => acc + d.padecimientos.length,
        0,
      );
    },

    seleccionados() {
      return this.listaPadecimientos.length;
    },

    estadoSeleccion() {
      if (this.seleccionados === 0) return "ninguno";
      if (this.seleccionados === this.totalPadecimientos) return "todo";
      return "parcial";
    },

    textoBoton() {
      if (this.estadoSeleccion === "todo") return "Limpiar todo";
      if (this.estadoSeleccion === "parcial") return "Completar selección";
      return "Seleccionar todo";
    },

    tieneEstudiosDisponibles() {
      return this.estudios.some((e) => e.existe && e.vigente);
    },
  },
  methods: {
    agregarOdontograma() {
      this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.AGREGAR_ODONTOGRAMA);
      this.bitacoraAccionDiagnocat();
      this.$emit("agregar-odontograma", {
        dientes: this.listaDientes,
        padecimientos: this.listaPadecimientos,
        idEstudio: this.accionDiagnocat.idEstudio,
        idAnalisis: this.accionDiagnocat.idAnalisis,
      });
      this.mostrarModalHdx = false;
    },
    seleccionarPad(diag, tooth, checked) {
      if (checked) {
        if (this.accionDiagnocat.idAccion.length === 0) this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.SELECCIONAR_PADECIMIENTO);
        this.bitacoraAccionDiagnocat();
        //  Agregar diente si no existe
        const existeDiente = this.listaDientes.some(
          (d) => d.idDiente === diag.idDiente,
        );

        if (!existeDiente) {
          this.listaDientes.push({
            idDiente: diag.idDiente,
            numDiente: diag.numDiente,
          });
        }

        //  Agregar padecimiento si no existe
        const existePad = this.listaPadecimientos.some(
          (p) =>
            p.idPadecimiento === tooth.idPadecimiento &&
            p.idDiente === diag.idDiente,
        );

        if (!existePad) {
          this.listaPadecimientos.push({
            idPadecimiento: tooth.idPadecimiento,
            descripcion: tooth.padecimiento,
            idClasificacionClinica: tooth.idClasificacionClinica,
            idDiente: diag.idDiente,
          });
        }
      } else {
        this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.DESELECCIONAR_PADECIMIENTO);
        this.bitacoraAccionDiagnocat();
        //  Quitar padecimiento
        this.listaPadecimientos = this.listaPadecimientos.filter(
          (p) =>
            !(
              p.idPadecimiento === tooth.idPadecimiento &&
              p.idDiente === diag.idDiente
            ),
        );

        //  Si el diente ya no tiene padecimientos, quitarlo
        const tienePads = this.listaPadecimientos.some(
          (p) => p.idDiente === diag.idDiente,
        );

        if (!tienePads) {
          this.listaDientes = this.listaDientes.filter(
            (d) => d.idDiente !== diag.idDiente,
          );
        }
      }
    },

    toggleTodo() {
      if (this.estadoSeleccion === "todo") {
        this.listaDientes = [];
        this.listaPadecimientos = [];

        // desmarcar visualmente los checkboxes
        this.diagnosticos.forEach((diag) => {
          diag.padecimientos.forEach((tooth) => {
            tooth.checked = false;
            if (this.accionDiagnocat.idAccion.length === 0) this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.DESELECCIONAR_PADECIMIENTO);
            this.bitacoraAccionDiagnocat();
          });
        });
        return;
      }

      //  marcar visualmente y lógica existente marcando cada padecimiento diente
      this.diagnosticos.forEach((diag) => {
        diag.padecimientos.forEach((tooth) => {
          if (!tooth.checked) {
            tooth.checked = true;
            this.seleccionarPad(diag, tooth, true);
          }
        });
      });
    },

    async flujoInicialDiagnocat(abrirModal) {
      this.loading = true;
      this.loadingDiagnostico = true;
      this.colapsado = false;
      this.$swal.fire({
        html: `
          <div style="display: flex; flex-direction: column; align-items: center; gap: 16px;">
            <div style="position: relative; width: 70px; height: 70px;">
              <div style="
                position: absolute; inset: 0;
                border: 3px solid #e0e0e0;
                border-top: 3px solid #7C6FF7;
                border-radius: 50%;
                animation: spin 0.9s linear infinite;
              "></div>
              <img
                src="${require('../../assets/version5/diagnocat.png')}"
                alt="Diagnocat"
                style="
                  position: absolute;
                  top: 50%; left: 50%;
                  transform: translate(-50%, -50%);
                  width: 45px; height: 45px;
                  border-radius: 8px;
                "
              />
            </div>
            <span>Cargando estudios, por favor espere</span>
          </div>
          <style>
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          </style>
        `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.reiniciarVariables();
      const hayPaciente = await this.obtenerPaciente();
      this.accionDiagnocat.idPaciente = Number(this.idPaciente);
      this.accionDiagnocat.idSesion = this.idSesion;
      //validamos si esta abriendo el modal o esta recargando los estudios
      this.accionDiagnocat.idAccion.push(abrirModal ? this.accionesDiagnocat.ABRIR_MODAL : this.accionesDiagnocat.RECARGAR_ESTUDIOS);
      if (!hayPaciente) {
        this.loading = false;
        this.bitacoraAccionDiagnocat();
        return;
      }
      this.obtenerEstBase();
      const hayEstudios = await this.obtenerEstudios();
      if (!hayEstudios) {
        this.loading = false;
        this.loadingDiagnostico = false;
        this.bitacoraAccionDiagnocat();
        return;
      }
      await this.seleccionarPrimerDisponible();
      this.abrirModal();
      this.loading = false;
      this.loadingDiagnostico = false;
      this.$swal.close();
    },

    reiniciarVariables() {
      this.estudioSeleccionado = null;
      this.indexSeleccionado = null;
      this.error = null;
      this.diagnosticos = [];
      this.listaDientes = [];
      this.listaPadecimientos = [];
      this.loadingPdf = false;
      this.indiceTabActivo = 0;
      this.descargaPdfActual = null;
    },

    abrirModal() {
      this.mostrarModalHdx = true;
    },

    cerrarModal() {
      this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.CERRAR_MODAL);
      this.bitacoraAccionDiagnocat();
      this.mostrarModalHdx = false;
    },

    async obtenerPaciente() {
      const parametros = {
        idPaciente: Number(this.idPaciente)
      };

      try {
        const response = await this.$http.post(
          this.$api + "diagnocat/obtenerDatosPacienteDiagnocat",
          parametros,
        );


        this.pacienteDiagnocat = response.data.data;

        if (!this.pacienteDiagnocat) {
          this.$swal({
            icon: "warning",
            text: "El paciente no se encuentra en Diagnocat",
            confirmButtonText: "De acuerdo",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }

        return true;
      } catch (error) {
        console.error("Error en obtenerPaciente:", error);
        return false;
      }
    },

    /**
     * Obtiene todos los estudios del paciente con sus análisis completos.
     * Siempre muestra los 4 tipos de estudios base (PANORAMA, FMX, PANOWING, CBCT)
     * aunque el paciente no los tenga o no estén vigentes.
     *
     * Flujo:
     * 1. Inicializar slots base (4 tipos, todos como "no disponible")
     * 2. Obtener estudios reales del paciente desde Diagnocat (idEndPoint 2)
     * 3. Por cada estudio real, obtener sus análisis en paralelo (idEndPoint 4)
     *    - Los análisis incluyen: vigencia, miniatura (preview_url) e id_v3
     *    - Se excluyen análisis de tipo STL
     *    - Se excluyen análisis con vigencia mayor a 6 meses (basado en updated_at o created_at)
     * 4. Resolver duplicados del mismo tipo:
     *    - Criterio 1: El más reciente (mayor created_at)
     *    - Criterio 2: En empate de fecha, el que tenga más análisis
     * 5. Mapear el estudio ganador de cada tipo a su slot base
     * 6. Poblar el slot PANOWING de forma independiente:
     *    - Busca en todos los estudios procesados si alguno contiene
     *      un análisis de tipo PANOWING dentro de su array de análisis
     *    - Si hay varios candidatos, gana el que tenga el PANOWING más reciente (updated_at)
     * 7. Ordenar: vigentes → no vigentes → no existen
     *
     * @returns {Promise<boolean>} true si hay al menos un estudio existente, false en caso contrario
     */
    async obtenerEstudios() {
      this.loading = true;

      try {
        // ─────────────────────────────────────────────
        // PASO 1: Inicializar slots base
        // Siempre se muestran los 4 tipos aunque no existan
        // en Diagnocat o no tengan vigencia válida
        // ─────────────────────────────────────────────
        this.estudios = this.estudiosBase.map((base) => ({
          studyType: base.studyType,       // Tipo: PANORAMA, FMX, PANOWING, CBCT
          nombreEstudio: base.nombreEstudio, // Nombre legible para el usuario
          uid: null,                         // UID del estudio en Diagnocat
          miniatura: null,                   // URL de la imagen preview (preview_url directo de Diagnocat)
          fechaAlta: null,                   // Fecha de creación del estudio
          fechaActualizacion: null,          // Fecha de última actualización
          vigente: false,                    // Si tiene al menos un análisis vigente
          existe: false,                     // Si el paciente tiene este estudio
          pdf: null,                         // Blob URL del PDF del reporte
          idV3: null,                       // UID del análisis (para diagnósticos y PDF)
          analisis: null,                    // Array completo de análisis del estudio
          numImagenes: null,                 // Cantidad de imágenes (solo FMX)
        }));

        // ─────────────────────────────────────────────
        // PASO 2: Obtener estudios reales del paciente
        // Puede retornar múltiples estudios del mismo tipo
        // Ej: 2 PANORAMA, 3 FMX, etc.
        // ─────────────────────────────────────────────
        const response = await this.$http.post(
            this.$api + "diagnocat/obtenerEstudiosPacienteDiagnocat",
                this.pacienteDiagnocat.listClinicasDiagnocatPaciente
        );
        this.estudiosPaciente = response.data.data;

        // ─────────────────────────────────────────────
        // CASO: El paciente no tiene estudios en Diagnocat
        // ─────────────────────────────────────────────
        if (!this.estudiosPaciente || this.estudiosPaciente.length === 0) {
          this.$swal({
            icon: "warning",
            text: "El paciente no cuenta con estudios registrados en Diagnocat",
            confirmButtonText: "De acuerdo",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }

        // ─────────────────────────────────────────────
        // CASO: El paciente no tiene estudios en Diagnocat
        // ─────────────────────────────────────────────
        if (!this.estudiosPaciente || this.estudiosPaciente.length === 0) {
          this.$swal({
            icon: "warning",
            text: "El paciente no cuenta con estudios registrados en Diagnocat",
            confirmButtonText: "De acuerdo",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }

        // ─────────────────────────────────────────────
        // PASO 3: Procesar cada estudio real en paralelo
        // Por cada estudio:
        //   - Obtiene sus análisis (idEndPoint 4)
        //   - Valida vigencia (al menos 1 análisis < 6 meses)
        //   - Extrae miniatura (preview_url del primer análisis con imagen)
        // ─────────────────────────────────────────────
        const promesasProcesamiento = this.estudiosPaciente.map(async (estudioPaciente) => {
          try {
            // Obtener análisis del estudio (contiene vigencia + preview_url + id_v3)
            const analisis = await this.obtenerDetalleEstudio(estudioPaciente);

            if (!analisis || analisis.length === 0) {
              return null;
            }

            // Si llegaron análisis es porque obtenerDetalleEstudio ya filtró
            // los no vigentes (> 6 meses) y los STL. Si el array tiene elementos, es vigente.
            const esVigente = analisis.length > 0;

            // Extraer la miniatura (preview_url directo, sin descarga)
            const miniatura = await this.extraerMiniaturaDeAnalisis(analisis);

            return {
              studyType: estudioPaciente.studyType,
              uid: estudioPaciente.uid,
              miniatura: miniatura,
              fechaAlta: estudioPaciente.createdAt,
              fechaActualizacion: this.obtenerFechaActualizacionReciente(analisis),
              vigente: esVigente,
              existe: true,
              idV3: analisis[0]?.uid || null, // UID del primer análisis
              analisis: analisis,
              numImagenes: null,
            };

          } catch (error) {
            console.error('Error procesando estudio:', estudioPaciente, error);
            return null;
          }
        });

        // Esperar a que todos los estudios terminen de procesarse
        const estudiosRealesProcesados = await Promise.all(promesasProcesamiento);

        // ─────────────────────────────────────────────
        // PASO 4: Resolver duplicados por tipo de estudio
        //
        // Mapa temporal { study_type → estudio }
        // Sirve para conservar un único estudio por tipo tras resolver duplicados
        // ─────────────────────────────────────────────
        const estudiosAgrupados = {};

        estudiosRealesProcesados.forEach((estudioReal) => {
          if (!estudioReal) return;

          const tipo = estudioReal.studyType;

          if (!estudiosAgrupados[tipo]) {
            estudiosAgrupados[tipo] = {
              ...estudioReal,
              // Desde el inicio excluir análisis PANOWING del estudio base
              analisis: estudioReal.analisis.filter(a => a.analysisType !== "PANOWING"),
            };
            return;
          }

          const actual = estudiosAgrupados[tipo];

          // Fusionar solo análisis que NO sean PANOWING y que no estén duplicados
          if (estudioReal.analisis?.length > 0) {
            const uidsExistentes = new Set(actual.analisis.map(a => a.uid));
            const analisisNuevos = estudioReal.analisis.filter(a =>
                a.analysisType !== "PANOWING" &&  // ← excluir PANOWING
                !uidsExistentes.has(a.uid)          // ← excluir duplicados
            );
            actual.analisis = [...actual.analisis, ...analisisNuevos];
          }

          // Actualizar metadata si el nuevo es más reciente
          const fechaActual = new Date(actual.fechaAlta);
          const fechaNuevo  = new Date(estudioReal.fechaAlta);

          if (fechaNuevo > fechaActual) {
            actual.uid                = estudioReal.uid;
            actual.miniatura          = estudioReal.miniatura;
            actual.fechaAlta          = estudioReal.fechaAlta;
            actual.fechaActualizacion = estudioReal.fechaActualizacion;
            actual.idV3              = estudioReal.idV3;
          }

          if (estudioReal.vigente) {
            actual.vigente = true;
          }
        });

        // ─────────────────────────────────────────────
        // PASO 5: Mapear estudios ganadores a sus slots base
        // Solo se actualiza el slot del tipo correspondiente
        // Los slots sin estudio real quedan como "no disponible"
        // ─────────────────────────────────────────────
        Object.values(estudiosAgrupados).forEach((estudioReal) => {
          const slotBase = this.estudios.find(
              (e) => e.studyType === estudioReal.studyType
          );

          if (slotBase) {
            slotBase.uid                = estudioReal.uid;
            slotBase.miniatura          = estudioReal.miniatura;
            slotBase.fechaAlta          = estudioReal.fechaAlta;
            slotBase.fechaActualizacion = estudioReal.fechaActualizacion;
            slotBase.vigente            = estudioReal.vigente;
            slotBase.existe             = true;
            slotBase.idV3              = estudioReal.idV3;
            slotBase.analisis           = estudioReal.analisis;
            slotBase.numImagenes        = estudioReal.numImagenes;
          }
        });

        // ─────────────────────────────────────────────
        // PASO 6: Poblar slot PANOWING de forma independiente
        // Busca en TODOS los estudios procesados si alguno
        // tiene un análisis de tipo PANOWING dentro de su array
        // y puebla el slot correspondiente
        // ─────────────────────────────────────────────
        const estudiosConPanowing = estudiosRealesProcesados.filter(
            e => e !== null && e.analisis?.some(a => a.analysisType === "PANOWING")
        );

        if (estudiosConPanowing.length > 0) {
          // Si hay varios estudios con PANOWING, tomar el más reciente
          const ganador = estudiosConPanowing.reduce((a, b) => {
            const anPanowingA = a.analisis.find(an => an.analysisType === "PANOWING");
            const anPanowingB = b.analisis.find(an => an.analysisType === "PANOWING");
            const fechaA = new Date(anPanowingA.updatedAt || anPanowingA.createdAt);
            const fechaB = new Date(anPanowingB.updatedAt || anPanowingB.createdAt);
            return fechaB > fechaA ? b : a;
          });

          const anPanowing   = ganador.analisis.find(a => a.analysisType === "PANOWING");
          const slotPanowing = this.estudios.find(e => e.studyType === "PANOWING");

          if (slotPanowing && anPanowing) {
            slotPanowing.uid                = ganador.uid;
            slotPanowing.miniatura          = anPanowing.previewUrl || null;
            slotPanowing.fechaAlta          = anPanowing.createdAt;
            slotPanowing.fechaActualizacion = anPanowing.updatedAt || anPanowing.createdAt;
            slotPanowing.vigente            = true;
            slotPanowing.existe             = true;
            slotPanowing.idV3              = anPanowing.uid;
            slotPanowing.analisis           = [anPanowing];
          }
        }

        // ─────────────────────────────────────────────
        // PASO 7: Ordenar estudios para la visualización
        //
        // Orden de prioridad:
        //   1º → Existen + Vigentes   (disponibles para consultar)
        //   2º → Existen + No vigentes (realizados pero vencidos)
        //   3º → No existen           (nunca realizados al paciente)
        //
        // Dentro de cada grupo, ordenar por fecha más reciente
        // ─────────────────────────────────────────────
        this.estudios.sort((a, b) => {
          // 1º Prioridad: Existen y son vigentes
          if (a.existe && a.vigente && !(b.existe && b.vigente)) return -1;
          if (!(a.existe && a.vigente) && b.existe && b.vigente) return 1;

          // 2º Prioridad: Existen pero no son vigentes
          if (a.existe && !b.existe) return -1;
          if (!a.existe && b.existe) return 1;

          // Si ambos existen, ordenar por fecha más reciente
          if (a.existe && b.existe) {
            const fechaA = new Date(a.fechaAlta);
            const fechaB = new Date(b.fechaAlta);
            return fechaB - fechaA;
          }

          // Si ninguno existe, mantener orden original (PANORAMA, FMX, PANOWING, CBCT)
          return 0;
        });


        return true
      } catch (e) {
        console.error("Error en obtenerEstudios:", e);
        this.$swal({
          icon: "error",
          text: "Ocurrió un error al obtener los estudios de Diagnocat",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      } finally {
        this.loading = false;
      }
    },

    obtenerEstBase() {
      this.estudiosBase = this.obtenerEstudiosBasePorTipo();
    },

    /**
     * Obtiene los análisis completos de un estudio
     * Filtra y retorna SOLO los análisis vigentes (< 6 meses)
     *
     * Usa idEndPoint 4: GET /v2/studies/:idStudio/analyses
     *
     * @param {Object} estudio - Objeto del estudio
     * @returns {Promise<Array>} Array de análisis vigentes o array vacío
     */
    async obtenerDetalleEstudio(estudio) {

      try {
        const response = await this.$http.post(
            this.$api + "diagnocat/obtenerEstudiosPdfPacienteDiagnocat",
            estudio,
        );

        if (!response || !response.data || !response.data.data) {
          return [];
        }

        const respuesta = response.data.data;

        if (!Array.isArray(respuesta)) {
          return [];
        }

        // Filtrar solo los análisis vigentes (< 6 meses) y que no sean STL
        return respuesta.filter((item) => {
          // Excluir análisis de tipo STL
          if (item.analysisType === "STL") return false;

          const createdAt = item.createdAt;
          const updatedAt = item.updatedAt;

          if (!createdAt) return false;

          const hoy = new Date();

          // Si created_at y updated_at son iguales o no hay updated_at
          // solo validar created_at
          if (!updatedAt || createdAt === updatedAt) {
            const limiteCreacion = new Date(createdAt);
            limiteCreacion.setMonth(limiteCreacion.getMonth() + 6);
            return hoy <= limiteCreacion;
          }

          // Si updated_at existe y es diferente, priorizarlo
          // Si updated_at es vigente → el análisis es vigente
          // aunque created_at no lo sea
          const limiteActualizacion = new Date(updatedAt);
          limiteActualizacion.setMonth(limiteActualizacion.getMonth() + 6);

          return hoy <= limiteActualizacion;
        });

      } catch (error) {
        console.error(`Error obteniendo análisis para ${estudio.uid}:`, error);
        return [];
      }
    },

    /**
     * Extrae y procesa la miniatura desde el análisis
     * Busca el primer análisis con preview_url válido
     * Lo retorna para agregarse al elemento img src=""
     *
     * @param {Array} analisis - Array de análisis del estudio
     * @returns {Promise<string|null>} elemento preview_url o null si falla
     */
    async extraerMiniaturaDeAnalisis(analisis) {
      if (!Array.isArray(analisis) || analisis.length === 0) {
        return null;
      }

      // Buscar el primer análisis que tenga preview_url válido
      const analisisConMiniatura = analisis.find((a) => a.previewUrl);

      if (!analisisConMiniatura || !analisisConMiniatura.previewUrl) {
        return null;
      }else{
        return analisisConMiniatura.previewUrl;
      }
    },

    /**
     * Obtiene la fecha de actualización más reciente del array de análisis
     * Compara todos los updated_at y retorna el mayor
     * Si no hay updated_at, usa created_at como fallback
     *
     * @param {Array} analisis - Array de análisis del estudio
     * @returns {string|null} Fecha más reciente o null
     */
    obtenerFechaActualizacionReciente(analisis) {
      if (!Array.isArray(analisis) || analisis.length === 0) return null;

      return analisis.reduce((fechaMasReciente, item) => {
        // Usar updated_at si existe y es diferente, sino created_at
        const fechaItem = (item.updatedAt && item.updatedAt !== item.createdAt)
            ? item.updatedAt
            : item.createdAt;

        if (!fechaMasReciente) return fechaItem;

        return new Date(fechaItem) > new Date(fechaMasReciente)
            ? fechaItem
            : fechaMasReciente;
      }, null);
    },

    obtenerEstudiosBasePorTipo() {
      return [
        {
          studyType: "FMX",
          nombreEstudio: "Rx Iox", // radiografías periapicales
        },
        {
          studyType: "PANORAMA",
          nombreEstudio: "Rx Pano", //radiografía panorámica
        },
        {
          studyType: "PANOWING",
          nombreEstudio: "RX Panowings" }, //radiografía aleta de mordida
        {
          studyType: "CBCT",
          nombreEstudio: "CBCT" }, //tomografía
      ];
    },

    async seleccionarEstudio(index) {
      // Cancelar cualquier descarga en curso y resetear estado
      this.descargaPdfActual = null;
      this.loadingPdf = false;

      this.indiceTabActivo = 0;
      this.diagnosticos = [];
      this.listaDientes = [];
      this.listaPadecimientos = [];
      this.estudioSeleccionado = this.estudios[index];
      this.indexSeleccionado = index;
      //validar si viene de una accion en cadena o acaba de seleccionar un estudio
      this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.SELECCIONAR_ESTUDIO);
      this.accionDiagnocat.idEstudio = this.estudioSeleccionado.uid;
      if (this.estudioSeleccionado.vigente === true && this.estudioSeleccionado.existe === true) {
        this.loadingDiagnostico = true;
        await this.descargarPDF(this.estudioSeleccionado, 1);
        await this.obtenerDiagnosticos(this.estudioSeleccionado, 1);
      }
      this.$forceUpdate();
    },

    async seleccionarPrimerDisponible() {
      try {
        const idx = this.estudios.findIndex((e) => e.existe && e.vigente);
        if (idx === -1) {
          this.estudioSeleccionado = null;
        } else {
          await this.seleccionarEstudio(idx);
        }
      } catch (error) {
        console.error("Error en seleccionarPrimerDisponible:", error);
      }
    },

    async obtenerDiagnosticos(estudioSeleccionado, tipo) {
      try {
        let estudioAux = tipo === 1? estudioSeleccionado.analisis[0]: estudioSeleccionado;
        estudioAux.idTagMotivoCita = this.idTagMotivoCita;
        estudioAux.idTipoDenticion = this.idTipoDenticion;

        if (tipo === 1) this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.SELECCIONAR_DIAGNOSTICO);
        this.accionDiagnocat.idAnalisis = estudioAux.uid;
        this.bitacoraAccionDiagnocat();

        this.listaPadecimientos = []
        this.diagnosticos = []
        this.$http
            .post(this.$api + "diagnocat/obtenerDiagnostico", estudioAux)
            .then((resp) => {
              if (resp.data.data){
                this.diagnosticos = resp.data.data
                this.diagnosticos.forEach(diag => {
                  diag.padecimientos.forEach(tooth => {
                    this.$set(tooth, 'checked', false)
                  })
                })
                this.loadingDiagnostico = false;
              }
            })
      }catch (error) {
        console.error("No existen padecimientos para este paciente", error);
        this.$swal({
          icon: "error",
          text: "Ocurrió un error al obtener los diagnósticos",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9",
        });
        this.loadingDiagnostico = false;
      }
    },

    async descargarPDF(estudio, tipo) {
      const idDescarga = Date.now() + Math.random();
      this.descargaPdfActual = idDescarga;
      let estudioAux = tipo === 1? estudio.analisis[0]: estudio;

      try {
        this.loadingPdf = true;

        const res = await this.$http.post(
          this.$api + "diagnocat/obtenerPDF",
            estudioAux,
        );

        // Verificar que esta descarga sigue siendo la actual
        if (this.descargaPdfActual !== idDescarga) {
          return;
        }

        const base64 = res.data.data;

        if (!base64) {
          console.error("No se recibió base64 del PDF");
          this.loadingPdf = false;
          return;
        }

        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
          bytes[i] = binary.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const analisis = this.estudioSeleccionado.analisis
            .find(a => a.uid === estudioAux.uid);

        if (analisis) {
          this.$set(analisis, "pdf", url);
        }

        this.loadingPdf = false;
        this.$forceUpdate();
      } catch (error) {
        console.error("Error al descargar PDF:", error);
        this.error = "No se encontró PDF para este estudio";
        this.$swal({
          icon: "error",
          text: "Ocurrió un error al descargar el PDF del estudio",
          confirmButtonText: "De acuerdo",
          confirmButtonColor: "#0e6ba9",
        });
        this.loadingPdf = false;
      }
    },
    async seleccionarAnalisis(index) {

      const analisis =
          this.estudioSeleccionado.analisis[index];

      // Cancelar cualquier descarga en curso y resetear estado
      this.descargaPdfActual = null;
      this.loadingPdf = false;

      this.listaPadecimientos = [];
      this.diagnosticos = [];

      if (!analisis) return;

      if (!analisis.pdf) {
        await this.descargarPDF(analisis);
      }

      this.accionDiagnocat.idAccion.push(this.accionesDiagnocat.SELECCIONAR_DIAGNOSTICO);
      await this.obtenerDiagnosticos(analisis, 2);
    },

    /**
     * Maneja el error de carga de una imagen
     * Si la imagen no se puede cargar (URL rota, sin preview_url, etc.)
     * la reemplaza con la imagen por defecto de Diagnocat
     *
     * @param {Event} event - Evento de error del elemento img
     * @param {Object} estudio - Objeto del estudio al que pertenece la imagen
     */
    onImageError(event, estudio) {
      event.target.src = require("../../assets/version5/diagnocat.png");
      this.$set(estudio, 'miniaturaFallida', true);
    },

    abrirCarruselEstudio(estudio) {
      // No abrir carrusel si la miniatura del estudio falló
      if (estudio && estudio.miniaturaFallida) {
        return;
      }

      this.tituloCarrusel = (estudio && estudio.nombreEstudio) ? estudio.nombreEstudio : "Previsualización del estudio";

      const analisis = estudio && Array.isArray(estudio.analisis) ? estudio.analisis : [];
      const analisisConUrl = analisis.filter((a) => a && typeof a.previewUrl === "string" && a.previewUrl.trim().length > 0);

      // Validar que haya imágenes válidas antes de abrir el carrusel
      if (analisisConUrl.length === 0) {
        return;
      }

      this.carruselAnalisis = analisisConUrl;
      const urls = analisisConUrl.map((a) => a.previewUrl);
      this.carruselUrls = urls;
      this.carruselIndex = 0;
      this.modalCarrusel = true;
    },

    bitacoraAccionDiagnocat(){
      this.$http.post( this.$api + "version5/bitacoraAccionesDiagnocat/guardarAccionesDiagnocat", this.accionDiagnocat).finally(()=> this.accionDiagnocat.idAccion = []);
    },


  },
};
</script>

<style scoped>
.sombraModales {
  filter: drop-shadow(2px 1px 4px rgba(0, 0, 0, 0.25));
}

.modal-movil {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  -webkit-box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  cursor: move;
  z-index: 1000;
  border-radius: 23px;
}

.border-card {
  border: 1px solid rgb(220, 220, 220);
  border-radius: 20px;
  min-height: 480px;
}

.title-card {
  color: #5a5a5a;
  font-size: 14px;
  font-weight: 500;
}

.title-card-inactive {
  color: #898989;
  font-size: 14px;
  font-weight: 500;
}

.estudio-seleccionado {
  background-color: #ececec;
  border-radius: 10px;
}

.btn-actualizar {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #1b81af;
  border-radius: 100px;
  height: 30px;
  width: 30px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.tooth-container {
  position: relative;
  width: 40px;
  height: 40px;
  padding: 0;
  display: flex;
  justify-content: center;
}

.tooth-number {
  position: absolute;
  font-size: 12px;
  font-weight: bold;
}

.tooth-icon-lg{
  display: inline-block;
  width: 37px;   /* ajusta a gusto */
  height: 37px;  /* ajusta a gusto */
  vertical-align: middle;
}

.diagnostico-item {
  padding: 12px;
  margin-bottom: 16px;
  background: #48b8ff36;
  border-radius: 15px;
}
.sidebar-col {
  overflow: hidden;
}

.sidebar-col.is-collapsed {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.toogle-btn {
  font-size: 1.5rem;
}
</style>
